/**
 * Renders one row per bundled cart item in a multi-item single-vendor order.
 *
 * The `line-item/cart-item` line items carry the price/quantity; the readable
 * title for each is read from `transaction.protectedData.cartItems` (stored by
 * initiate-privileged), paired by index. During the speculative checkout
 * preview the transaction has no protectedData yet, so we fall back to a
 * generic label — the real titles appear once the order is placed.
 */
import React from 'react';
import { intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_CART_ITEM, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemCartItemsMaybe = props => {
  const { lineItems, transaction, intl } = props;

  const cartLineItems = lineItems.filter(
    item => item.code === LINE_ITEM_CART_ITEM && !item.reversal
  );
  if (cartLineItems.length === 0) {
    return null;
  }

  const cartMeta = transaction?.attributes?.protectedData?.cartItems || [];

  return (
    <React.Fragment>
      {cartLineItems.map((item, i) => {
        const title = cartMeta[i]?.title || 'Vara i varukorgen';
        const quantity = item.quantity;
        const label = quantity && quantity > 1 ? `${quantity} × ${title}` : title;
        const formattedTotal = formatMoney(intl, item.lineTotal);
        return (
          <div key={`cart-item-${i}`} className={css.lineItem}>
            <span className={css.itemLabel}>{label}</span>
            <span className={css.itemValue}>{formattedTotal}</span>
          </div>
        );
      })}
    </React.Fragment>
  );
};

LineItemCartItemsMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemCartItemsMaybe;
